module.exports = __webpack_public_path__ + "img/content-yellow2.599eaec4.svg";